$primary: #82bc44;
$border: #eaeaea;
$text: #333;
$muted: #666;

.wrapper {
	font-family: system-ui, sans-serif;
	font-size: 0.85rem;
}

.table {
	width: 100%;
	border-collapse: collapse;
	margin-bottom: 1rem;

	.header {
		background: #f9f9f9;

		th {
			border-bottom: 2px solid $border;
		}
	}

	th,
	td {
		padding: 0.5rem;
		border-bottom: 1px solid $border;
	}

	th {
		text-align: left;
		font-weight: 600;
		color: $text;
	}

	tfoot {
		tr {
			background: #f2f2f2;

			td {
				font-weight: 600;
				border-top: 2px solid $border;
			}
		}
	}
}

.periodRow {
	cursor: pointer;

	&:hover {
		background: rgba(0, 0, 0, 0.03);
	}
}

.icon {
	color: $primary;
	vertical-align: middle;
	margin-right: 0.4rem;
	transition: transform 0.2s ease;
}

.rotated {
	transform: rotate(90deg);
}

.detailCell {
	padding: 0;
	background: #fafafa;
}

.detailTable {
	width: 100%;
	border-collapse: collapse;

	th,
	td {
		padding: 0.4rem;
		border: 1px solid $border;
		vertical-align: middle;
	}

	th {
		background: #fafafa;
		text-align: left;
		font-weight: 600;
		color: $text;
	}

	tr:nth-child(even) {
		background: #fff;
	}
}

.productName {
	font-weight: 500;
	color: $text;
}

.right {
	text-align: right !important;
}

.moreCell {
	text-align: center;
	padding: 0.5rem 0;
}

.moreBtn {
	background: none;
	border: none;
	color: $primary;
	font-size: 0.85rem;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
	}
}

.alert {
	margin-top: 0.5rem;
	padding: 0.5rem 0.8rem;
	background: #fff3cd;
	border: 1px solid #ffeeba;
	border-radius: 4px;
	font-size: 0.85rem;
	color: #856404;

	strong {
		color: #c09853;
	}
}
